import { useEffect } from "react";
import { useAppDispatch } from "../../hooks/hooks";
import { getMemberExperienceDataAsync } from "../../features/authentication/authenticationSlice";
import {
  getAllListsAsync,
  getAllReportsWithNotesAsync,
  getReportHistoryAsync,
} from "../../features/reports/reportsSlice";
import {
  getMonitoringAsync,
  getNeighborhoodWatchMonitoringAreasAsync,
  getPropertyMonitoringAsync,
} from "../../features/monitoring/monitoringSlice";

interface TESTGrabNewState {}

const TestGrabNewState: React.FC<TESTGrabNewState> = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(getMemberExperienceDataAsync());

        // get report history
        dispatch(getReportHistoryAsync());

        // trigger get monitoring
        dispatch(getMonitoringAsync());
        dispatch(getNeighborhoodWatchMonitoringAreasAsync());
        dispatch(getPropertyMonitoringAsync());

        // get lists data
        dispatch(getAllListsAsync());

        // get notes data
        dispatch(getAllReportsWithNotesAsync());
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  return <div>Pulling State</div>;
};

export default TestGrabNewState;
